import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';

import './HiwStepTitle.scss';

const HiwStepTitle = ({ stepNumber, title }) => (
  <div>
    <div className="hiw-step-title__step-number">
      {trans('listings.how-to-book.step', { stepNumber }).toUpperCase()}
    </div>
    <h2 className="hiw-step-title__title">{title}</h2>
  </div>
);

HiwStepTitle.propTypes = {
  stepNumber: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired
};

export default HiwStepTitle;
